import Image from 'next/image';
import ReactDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';

import {
  FormValidationErrorMessage,
  InputLabel,
  TimeDropDown
} from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';

const DatepickerInput = ({ ...props }) => (
  <input
    type='text'
    {...props}
    readOnly
  />
);

const EventDateTime = ({ control, errors, isMobile, setValue, watch }) => (
  <div className='block md:flex w-full space-y-4 md:space-x-7 md:space-y-0 relative mt-4 md:mt-6'>
    <div className='group w-full md:w-1/2'>
      <InputLabel
        className='text-sm md:text-base font-Montserrat text-nero font-medium mb-2 md:mb-4 block'
        required
      >
        Event Date
      </InputLabel>
      <div
        className={`${
          errors.eventDate
            ? 'border border-cinnabar animate-shadow-pulse'
            : 'border-transparent'
        } flex text-sm font-medium rounded-md h-12.5 justify-start items-center shadow-category group-hover:shadow-list bg-white cursor-pointer`}
      >
        <div className='flex items-center ms-3 md:ms-4'>
          <Image
            alt='Event Date'
            height={18}
            width={18}
            src={
              watch('eventDate')
                ? `${staticMediaStoreBaseURL}/icons/calendar-black.svg`
                : `${staticMediaStoreBaseURL}/icons/calender-grey.svg`
            }
            style={{
              width: '18px',
              height: '18px',
              objectFit: 'contain'
            }}
          />
        </div>
        <Controller
          control={control}
          name='eventDate'
          render={({ field }) => (
            <ReactDatePicker
              autoComplete='off'
              className='block outline-none w-full text-sm font-medium h-8 p-2 pr-0 rounded for-ios cursor-pointer'
              customInput={<DatepickerInput />}
              dateFormat='dd/MM/yyyy'
              minDate={new Date()}
              name='eventDate'
              onChange={(date) => {
                setValue('eventDate', date);
                field.onChange(date);
              }}
              placeholderText='Choose Event Date'
              popperModifiers={{ preventOverflow: { enabled: true } }}
              scrollableYearDropdown
              selected={field.value}
              showMonthDropdown
              showYearDropdown
              withPortal={isMobile}
            />
          )}
          rules={{ required: 'Please choose event date' }}
        />
      </div>
      {errors?.eventDate && (
        <FormValidationErrorMessage message={errors.eventDate.message} />
      )}
    </div>
    <div className='group w-full md:w-1/2'>
      <InputLabel
        className='text-sm md:text-base font-Montserrat text-nero font-medium mb-2 md:mb-4 block'
        required
      >
        Event start time
      </InputLabel>
      <div
        className={`${
          errors.eventTime
            ? 'border border-cinnabar animate-shadow-pulse'
            : 'border-transparent'
        } flex text-silver rounded-md h-12.5 justify-start items-center shadow-category group-hover:shadow-list bg-white cursor-pointer`}
      >
        <div className='flex items-center ms-3 md:ms-4'>
          <Image
            alt='Event Time'
            height={18}
            width={18}
            src={
              watch('eventTime')
                ? `${staticMediaStoreBaseURL}/icons/clock-icon-black.svg`
                : `${staticMediaStoreBaseURL}/icons/clock-lightgrey.svg`
            }
            style={{
              width: '18px',
              height: '18px',
              objectFit: 'contain'
            }}
          />
        </div>
        <Controller
          control={control}
          name='eventTime'
          render={({ field }) => (
            <TimeDropDown
              eventTime={field.value}
              handleEventTime={(e) => field.onChange(e.target.value)}
            />
          )}
          rules={{ required: 'Please choose event time' }}
        />
      </div>
      {errors?.eventTime && (
        <FormValidationErrorMessage message={errors.eventTime.message} />
      )}
    </div>
  </div>
);

export default EventDateTime;
